const isOnboardingCompletedLocalStorageKey = 'isOnboardingCompleted';
export const isOnboardingCompletedOnLocalStorage = () => {
    const isCompletedString = localStorage.getItem(isOnboardingCompletedLocalStorageKey);
    return JSON.parse(isCompletedString);
};
export const setOnboardingCompletedOnLocalStorage = () => {
    localStorage.setItem(isOnboardingCompletedLocalStorageKey, 'true');
};
